









import Vue, { PropType } from "vue";
import PopoverSelectBox from "@/components/Atoms/Forms/PopoverSelectBox/index.vue";

import { Data, Methods, Computed, Props } from "./types";
import { BUSINESS_CATEGORY_OPTIONS } from "@/constants/company";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "BusinessCategorySelectBox",
  components: {
    PopoverSelectBox
  },
  model: {
    prop: "selectedCategory",
    event: "input"
  },
  props: {
    selectedCategory: {
      type: String as PropType<Props["selectedCategory"]>,
      required: true,
      default: ""
    }
  },
  data() {
    return {
      businessCategoryOptions: BUSINESS_CATEGORY_OPTIONS
    };
  },
  computed: {
    computeSelectedCategory: {
      get() {
        return this.selectedCategory;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
});
